import { Crown } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UnlimitedBookingBannerProps {
  onBook: () => void;
  isProcessing: boolean;
  isSoldOut: boolean;
  daysRemaining: number | null;
  eventStartTime: string;
  unlimitedExpiresAt: Date | null;
}

const UnlimitedBookingBanner = ({
  onBook,
  isProcessing,
  isSoldOut,
  daysRemaining,
}: UnlimitedBookingBannerProps) => {
  if (isSoldOut) {
    return (
      <div className="space-y-3">
        <div className="bg-gradient-to-r from-amber-500/20 to-yellow-500/20 border border-amber-500/40 rounded-lg p-3 flex items-center gap-2">
          <Crown className="h-5 w-5 text-amber-500" />
          <span className="text-sm font-medium text-amber-700 dark:text-amber-400">
            Unlimited Member
          </span>
        </div>
        <Button disabled className="w-full" size="lg">
          Sold Out
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="bg-gradient-to-r from-amber-500/20 to-yellow-500/20 border border-amber-500/40 rounded-lg p-3">
        <div className="flex items-center gap-2 mb-2">
          <Crown className="h-5 w-5 text-amber-500" />
          <span className="text-sm font-bold text-amber-700 dark:text-amber-400">
            Unlimited Member
          </span>
        </div>
        <p className="text-xs text-muted-foreground">
          Book this experience for free! (1 ticket per event)
          {daysRemaining && (
            <span className="block mt-1">{daysRemaining} days remaining</span>
          )}
        </p>
      </div>

      <Button
        onClick={onBook}
        disabled={isProcessing}
        className="w-full bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-white font-semibold"
        size="lg"
      >
        {isProcessing ? "Processing..." : "Book Free (1 Ticket)"}
      </Button>
    </div>
  );
};

export default UnlimitedBookingBanner;
